import P2PRecieved from "@assets/icons/p2p-recieved.svg";
import P2PSent from "@assets/icons/p2p-sent.svg";
import PrimeReceive from "@assets/icons/Prime_receive.svg";
import PrimeSend from "@assets/icons/Prime_send.svg";
import ReferralCredit from "@assets/icons/referral-credit.svg";
import ScratchCard from "@assets/icons/scratch-card.svg";
import React from "react";

interface TransactionTypeSymbolsProps {
  transactionType: string;
  ledger: string;
}

const TransactionTypeSymbols: React.FC<TransactionTypeSymbolsProps> = ({
  transactionType,
  ledger,
}) => {
  return (
    <div
      className={`${
        ledger === "CR" ? "bg-bg-status-green" : "bg-bg-status-red"
      } rounded-full h-[24px] p-[2px] w-[24px] mr-[8px] flex items-center justify-center`}>
      {(() => {
        // Mapping logic for icons
        if (!transactionType || !ledger) {
          return null; // Handle case where transactionData is undefined
        }

        // Logic for types 1-6
        if (
          [
            "Personal Payin",
            "Personal Payout",
            "Merchant Payin",
            "Merchant Payout",
            "Internal Payin",
            "Internal Payout",
          ].includes(transactionType)
        ) {
          return ledger === "CR" ? (
            <span className="material-symbols-outlined">call_received</span>
          ) : (
            <span className="material-symbols-outlined">call_made</span>
          );
        }

        // Logic for types 7-12
        switch (transactionType) {
          case "Escrow Payin":
          case "Escrow Payout Reversal":
            return <img src={P2PRecieved} alt="P2P Received" />;
          case "Escrow Payout":
          case "Escrow Payin Reversal":
            return <img src={P2PSent} alt="P2P Sent" />;
          case "Merchant Escrow Payin":
          case "Merchant Escrow Payout Reversal":
          case "Prime Merchant Credit":
          case "Prime Revenue Credit":
          case "Prime Cashier Debit Reversed":
            return <img src={PrimeReceive} alt="Prime Receive" />;
          case "Merchant Escrow Payout":
          case "Merchant Escrow Payin Reversal":
          case "Prime Cashier Debit":
            return <img src={PrimeSend} alt="Prime Send" />;
          case "Tiered Referral Credit":
          case "Referral Credit":
            return <img src={ReferralCredit} alt="Referral Credit" />;
          case "Scratch Card Credit":
            return <img src={ScratchCard} alt="Scratch Card Credit" />;
          default:
            return <span className="material-symbols-outlined">payments</span>;
        }
      })()}
    </div>
  );
};

export default TransactionTypeSymbols;
